class MiniCart {
    constructor(opts = {
        cartClass: 'hc-mini-cart-opened',
        bodyClass: 'hc-mini-cart-opened',
        template: null,
        id: null,
        classes: {
            checkout: 'btn',
            viewcart: 'btn',
        }
    }) {
        if (!opts.id) {
            let id = '';
            for (let x = 0; x < 12; x++) id += '' + Math.floor(Math.random() * 10);
            this.id = id;
        }
        this._selectors0 = {
            count: 'data-cart-count',
            items: 'data-cart-items',
            item: 'data-cart-item',
            price: 'data-cart-total-price',
            quantityInput: 'data-cart-quantity',
            quantityChange: 'data-cart-quantity-change',
            close: `data-cart-close="${this.id}"`
        };
        this._selectors = {
            count: '[data-cart-count]',
            items: '[data-cart-items]',
            item: '[data-cart-item]',
            itemIdAttribute: 'data-cart-item',
            price: '[data-cart-total-price]',
            quantityInput: '[data-cart-quantity]',
            quantityChange: '[data-cart-quantity-change]',
            quantityChangeAttribute: 'data-cart-quantity-change',
            close: `[data-cart-close="${this.id}"]`
        };
        this.classes = {
            open: opts.cartClass || 'hc-mini-cart-opened',
            body: opts.bodyClass || 'hc-mini-cart-opened',
            etc: opts.classes || {},
        };
        if (!opts.template || !typeof opts.template == 'Function') this.renderFn = (cart, ctx) => {
            return `
<div class="hc-cart-overlay" data-cart-overlay ${ctx.selectors.close}></div>
<div class="hc-cart-contoiner" id="${cart.id}" data-cart-container>
<div class="hc-cart-header">
<div class="hc-close-btn" ${ctx.selectors.close}>×</div>
<div class="hc-cart-title">Your cart</div>
<div class="hc-cart-count" data-cart-count>${ctx.count}</div>
</div>
<div class="hc-cart-items" data-cart-items>
${ctx.items.map(item => `<a ${ctx.selectors.item}=${item.id} class="hc-cart-line-items" href="${item.url}">
<div class="hc-image-container">
<img src="${item.image}" />
</div>
<div class="hc-item-description">
<div class="hc-item-title">${item.title}</div>
<div class="hc-item-price">${ Shopify.formatMoney(item.price)}</div>
<div class="hc-item-quantity">
<div class="hc-item-quantity-negative" ${ctx.selectors.quantityChange}="-1">-</div>
<input ${ctx.selectors.quantityInput} type="number" min="1" value="${item.quantity}" />
<div class="hc-item-quantity-positive" ${ctx.selectors.quantityChange}="1">+</div>
<div class="spacer"></div>
<div class="hc-remove" ${ctx.selectors.quantityChange}="0">Remove</div>
</div>
</div>
</a>`).join('')}
</div>
<div class="hc-cart-subtotal">
  <span>Total: </span>
<span class="amount-price" ${ctx.selectors.price}>${Shopify.formatMoney(ctx.price)}</span>
</div>
  
  <div class="buttons">
	<a class="${ctx.classes.checkout} checkout" name="checkout" onclick="recurringOrdersCheckout(event)" href="/checkout">Checkout</a>
    <a class="${ctx.classes.viewcart}" href="/cart">View Cart</a>
  </div>
</div>
`;
        }

        // Events containers
        this._updates = [];
    }

    // Update cart function
    update() {
        if (!this.exists) {
            this.implement();
        }
        return fetch('/cart.js')
            .then(res => res.json())
            .then(cart => this.cart = cart)
            .then(cart => this.renderPreset(cart))
            .then(content => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(content, "text/html");
                return doc.querySelector('[data-cart-container]');
            })
            .then(content => this.refresh(content))

    }

    renderPreset(cart) {
        return this.renderFn(this, { cart, items: cart.items, count: cart.item_count, price: cart.total_price, selectors: this._selectors0, classes: this.classes.etc })
    }

    // Refresh cart content with a new content
    refresh(content) {
        console.log(this._el.querySelector(this._selectors.price).innerHTML);
        this._el.querySelector(this._selectors.count).innerHTML = content.querySelector(this._selectors.count).innerHTML;
        this._el.querySelector(this._selectors.items).innerHTML = content.querySelector(this._selectors.items).innerHTML;
        this._el.querySelector(this._selectors.price).innerHTML = content.querySelector(this._selectors.price).innerHTML;

        // Fire update events 
        console.log('[HC] Firing events');
        for (const cb of this._updates) {
            cb(content, this.cart);
        }

        return content;
    }

    // Open cart even if not implemented
    open() {
        if (!this.exists) {
            this.implement();
        }
        this._el.classList.add(this.classes.open);
        document.querySelector('body').classList.add(this.classes.body);
    }
    close() {
        this._el.classList.remove(this.classes.open);
        document.querySelector('body').classList.remove(this.classes.body);
    }
    updateQty(id, qty) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates: { [id]: qty } }),
        })
            .then(res => res.json())
            .then(cart => this.cart = cart)
            .then(cart => this.renderPreset(cart))
            .then(content => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(content, "text/html");
                return doc.querySelector('[data-cart-container]');
            })
            .then(content => this.refresh(content));
    }
    implement() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => this.cart = cart)
            .then(cart => this.renderPreset(cart))
            .then(content => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(content, "text/html");
                document.querySelector('body').append(doc.querySelector('[data-cart-overlay]'));
                return doc.querySelector('[data-cart-container]');
            })
            .then(el => { 
                document.querySelector('body').append(el);
                this._el = el;
                document.querySelector('body').addEventListener('input', (e) => {
                  
                console.log('[HC] Test');
                
                    if (e.target.matches(this._selectors.quantityInput)) {
                        console.log('[HC] Test2');
                        this.updateQty(e.target.closest(this._selectors.item).getAttribute(this._selectors.itemIdAttribute), e.target.value)
                    }
                });
                document.querySelector('body').addEventListener('click', (e) => {
                    if (e.target.matches(this._selectors.quantityInput)) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    if (e.target.matches(this._selectors.quantityChange)) {
                        const val = Number(e.target.getAttribute(this._selectors.quantityChangeAttribute));
                        const inp = e.target.closest(this._selectors.item).querySelector(this._selectors.quantityInput);
                        inp.value = val == 0 ? 0 : Number(e.target.closest(this._selectors.item).querySelector(this._selectors.quantityInput).value) + Number(val);
                        this.updateQty(e.target.closest(this._selectors.item).getAttribute(this._selectors.itemIdAttribute), inp.value)
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    if (e.target.matches(this._selectors.close)) {
                        this.close()
                    }
                });
                this.exists = true;
            });

    }
    // Events 
    onUpdate(cb) {
        this._updates.push(cb);
    }
  
}